/* MyTouchi – produktová nadstavba v1 (2026-10-22): odhalení při posunu a animovaná čísla */
(() => {
  const root = document.querySelector('[data-mpp]');
  if (!root) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = root.querySelectorAll('[data-mpp-reveal]');

  const countUp = (el) => {
    const target = parseFloat(el.dataset.mppCount);
    if (reduce || !target) return;
    const start = performance.now();
    const dur = 1100;
    const step = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * e);
      if (t < 1) requestAnimationFrame(step);
    };
    el.textContent = '0';
    requestAnimationFrame(step);
  };

  const show = (el) => {
    el.classList.add('is-visible');
    el.querySelectorAll('[data-mpp-count]').forEach(countUp);
  };

  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        show(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18 });
  items.forEach((el) => io.observe(el));
})();
